import { updateBalanceMessage } from './messages/updateBalance/updateBalanceMessage';
import { MessageGroup } from './types'; // ToDo: Core need to be refactored here

import { createMessage, MessageController } from './index';

export const hostInfoMessage = createMessage<'hostInfo', { host?: string; id: string | null }>('hostInfo', {
  group: MessageGroup.Common,
});

export const CoreLobbyMessageControllerV2 = new MessageController(
  ['lobby'],
  [
    {
      targets: ['lobby'],
      message: updateBalanceMessage,
    },
    {
      targets: ['lobby'],
      message: hostInfoMessage,
    },
  ]
);
